import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=e4f8cbc4&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=e4f8cbc4&prod&lang=css"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=e4f8cbc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f8cbc4",
  null
  
)

export default component.exports